module.exports = __webpack_public_path__ + "static/media/logout.e4d238ae.svg";